/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { OctagonExclamationIcon, TriangleExclamationIcon } from "../../FontAwesome";
import DialogBase from "../DialogBase";
import DialogContentText from "../DialogContentText";
import { translationKeys, useTranslation } from "./../../Internationalisierung/i18nBasis";
import YesNoDialogModel from "./YesNoDialogModel";
import YesNoDialogProps from "./YesNoDialogProps";

// Das SCSS des Dialogs muss in der App importiert werden
export default function YesNoDialog(props: YesNoDialogProps) {
    const { dialogAdditionalInformation } = props;
    const vm = new YesNoDialogModel(props);
    const { t } = useTranslation();

    return (
        <DialogBase open={vm.isOpen} onClose={vm.nein} aria-labelledby="form-dialog-title" maxWidth={props.maxWidth}>
            <div className={vm.innerContainerClassName}>
                {vm.isWarning && <div className={vm.warningIndicatorClassName}></div>}
                {vm.isDanger && <div className={vm.dangerIndicatorClassName}></div>}
                <div className={vm.mainClassName}>
                    <DialogTitle id="form-dialog-title">
                        <div className={vm.titleClassName}>
                            {vm.isWarning && (
                                <TriangleExclamationIcon className={vm.warningIconClassName} />
                            )}
                            {vm.isDanger && (
                                <OctagonExclamationIcon className={vm.dangerIconClassName} />
                            )}
                            {vm.dialogCaption}
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {vm.dialogText}
                            {typeof dialogAdditionalInformation !== "undefined" ? dialogAdditionalInformation : null}
                        </DialogContentText>
                        {props.children}
                    </DialogContent>
                    <DialogActions>
                        {props.additionalButtons}
                        <Button action={vm.yesButtonAction} onClick={vm.ja} disabled={props.jaDeaktivieren}>
                            {props.jaCaption ?? t(translationKeys.yesNoDialog.ja)}
                        </Button>
                        <Button action={vm.noButtonAction} onClick={vm.nein}>
                            {props.neinCaption ?? t(translationKeys.yesNoDialog.nein)}
                        </Button>
                    </DialogActions>
                </div>
            </div>
        </DialogBase>
    );
}
